import React, { useState } from 'react'
import { useAuth } from '../../applications/hooks/UseAuth'
import PlantationService from './services/Plantation'
import PageHeader from '../../components/Typography/PageHeader'
import PlantationsList from './components/listView/PlantationsList'
import PlantationDetailsPage from './components/pageView/PlantationDetailsPage'

import { Toolbar as MuiToolbar } from '@mui/material'
import BottomNavigation from '@mui/material/BottomNavigation'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import { makeStyles } from '@mui/styles'
import { useNavigate } from 'react-router-dom'
import ProvinceFilter from '../provinces/components/ProvinceFilter'

const CURRENT_PAGE = 'agroforestry_plantation'

const useStyles = makeStyles((theme) => ({
    siteChange: {
        '& .MuiBottomNavigation-root': {
            height: '50px',
            borderRadius: 10,
            borderColor: '#0FCB8F',
            borderWidth: 2,
            background: '#43D5A7'
        },
        '& .MuiBottomNavigationAction-root': {
            background: '#0FCB8F',
            minWidth: '18vw'
        },
        '& .MuiBottomNavigationAction-root.Mui-selected': {
            borderRadius: 10,
            background: 'none'
        },
        '& .MuiBottomNavigationAction-label': {
            fontSize: 15,
            color: '#FFFFFF'
        },
        '& .MuiBottomNavigationAction-root.Mui-selected .MuiBottomNavigationAction-label': {
            fontSize: 15,
            color: '#FFFFFF'
        }
    }
}))

function Plantations() {
    const classes = useStyles()

    const service = PlantationService.load()
    const { haveAccessTo } = useAuth()
    const [needLoad, setNeedLoad] = useState(true)
    const [filter, setFilter] = useState({})
    const [drawer, setDrawer] = useState(true)

    const [value, setValue] = useState('')

    const navigate = useNavigate()

    const handleChange = (event, newValue) => {
        setValue(newValue)
        navigate('/app/agroforestry/plantations/' + newValue)
    }

    return (
        <div className={'card w-full bg-base-100 font-sans font-bold'} style={{ paddingBottom: 20 }}>
            <PageHeader title={'Gestion plantations'} subTitle={'Gestion plantations'} />
            <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
                <ProvinceFilter setNeedLoad={setNeedLoad} filter={filter} setFilter={setFilter} />
                <MuiToolbar style={{ padding: 0, alignItems: 'start' }} className={classes.siteChange}>
                    <BottomNavigation showLabels value={value} onChange={handleChange}>
                        <BottomNavigationAction key="1" label="Plantations" value="" />
                        <BottomNavigationAction key="2" label="Paysans partenaires" value="peasants" />
                        <BottomNavigationAction key="3" label="Suivi des parcelles" value="plots" />
                    </BottomNavigation>
                </MuiToolbar>
            </div>
            <PlantationsList
                service={service}
                needLoad={needLoad}
                setNeedLoad={setNeedLoad}
                haveAccessTo={haveAccessTo}
                Form={PlantationDetailsPage}
                filterFromList={filter}
                drawer={drawer}
                currentPage={CURRENT_PAGE}
            />
        </div>
    )
}

export default Plantations
